import { EntityLinks, Goal, ID } from '@griply/types';

import { getArchivedGoalIds } from '../derived-goal-state';

export type FilterGoalsOptions = {
  links?: EntityLinks;
  hideUnplanned?: boolean;
  hideCompleted?: boolean;
  hideArchived?: boolean;
};

export const filterGoals = (
  goals: Goal[],
  { links, hideUnplanned, hideCompleted, hideArchived }: FilterGoalsOptions,
): Goal[] => {
  if (!hideUnplanned && !hideCompleted && !hideArchived) {
    return goals;
  }

  const archivedIds = hideArchived
    ? getArchivedGoalIds(goals, { links })
    : new Set<ID>();
  return goals.filter((goal) => {
    if (hideUnplanned && (!goal.startDate || !goal.deadline)) {
      return false;
    }

    if (hideCompleted && goal.completedAt) {
      return false;
    }

    return !(hideArchived && archivedIds.has(goal.id));
  });
};
